// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import utilsModel from "../../../../../engines/libs/utilsModel";
import utilsView from "../../../../../engines/libs/utilsView";
import { FileKind } from "../../../../define/FileKind";
import { GeneralKind } from "../../../../define/GeneralKind";
import { SettleLawsuitKind } from "../../../../define/SettleLawsuitKind";
import { backPackEventMap } from "../../../config/BackpackEventConfig";
import NormalGameManager from "../../../manager/NormalGameManager";
import ModelDialogLayer from "../../../../gameCommon/basic/ModelDialogLayer";
import SettleLawsuitPrimaryHeadCheck from "./SettleLawsuitPrimaryHeadCheck";
import SettleLawsuitPrimaryHeadNode from "./SettleLawsuitPrimaryHeadNode";
import SettleLawsuitPrimaryExhibitItem from "./SettleLawsuitPrimaryExhibitItem";
import SettleLawsuitPrimaryExhibitItem2 from "./SettleLawsuitPrimaryExhibitItem2";

const {ccclass, property} = cc._decorator;

/** 自己说话背景和文字位置差 */
const c_selfTalkSpaceY = 45;
@ccclass
export default class SettleLawsuitPrimarySelect extends BasePopUpLayer {

    @property(cc.Prefab)
    prefabExhibit: cc.Prefab = null;

	@property({ type: cc.Node, displayName:'' })
	nodePeopleItem: cc.Node = null;

	@property({ type: cc.ScrollView, displayName:'' })
	scrollExhibit: cc.ScrollView = null;

	@property({ type: cc.Label, displayName:'' })
	labelTalkHint: cc.Label = null;

    @property({ type: cc.Node, displayName:'' })
    sprHintDialog: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeHint: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeSelectCharge: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeSelectPeople: cc.Node = null;

    @property(cc.Prefab)
    prefabHead: cc.Prefab = null;

    @property(cc.Node)
    nodeItemCharge: cc.Node = null;

    @property({ type: cc.Label, displayName:'' })
	labelPropNum: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelPropName: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	sprPropBg: cc.Node = null;

	@property({ type: cc.Button, displayName:'' })
	btn_prop: cc.Button = null;

    @property({ type: cc.Node, displayName:'' })
	sprVideo: cc.Node = null;

    @property(cc.Button)
    btnJuedge: cc.Button = null;

    // private peopleScriptArr: SettleLawsuitPrimaryHeadCheck[] = [];
    // private curSelectPeople = 0;

    // private checkArr: cc.Toggle[] = [];

    // private curSelectType = -1;

    /** 最小高度 */
    // private minTalkHeight = 0;

    private propNum = 0;

    /**  */
    private toggleContainerArr: cc.ToggleContainer[] = [];

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.nodeItemCharge.active = false;
        this.nodePeopleItem.active = false;
        // this.minTalkHeight = this.sprHintDialog.height;

        this.initLayer();
    }

    initLayer() {
        this.showPeopleArr();
        this.showExhibit();
        this.refreshButtonState();
    }

    showExhibit() {
        let content = this.scrollExhibit.content;
        let lookExhibitList = this._carryData.lookExhibitList;
        for (let o of lookExhibitList) {
            if (o.trim() == '') {
                continue;
            }
            let prefabExhibit = cc.instantiate(this.prefabExhibit);
            content.addChild(prefabExhibit);

            let script = prefabExhibit.getComponent(SettleLawsuitPrimaryExhibitItem2);
            script.setCarryData({
                goodsId: o
            });
        }
        content.getComponent(cc.Layout).updateLayout();
        if (lookExhibitList.length < 4) {
            this.scrollExhibit.node.x = -content.width/2;
        }
    }
 
    showPeopleArr() {
        let peopleArr = this._carryData.peopleArr;
        let csvInfo = this._carryData.csvInfo;
        let judgment_select = utilsModel.splitLineFeed(csvInfo.judgment_select);
        for (let i = 0; i < peopleArr.length; i++) {
            let o = peopleArr[i];
            let strSelect = judgment_select[i];
            let toggleArr = strSelect.split(FileKind.ResParseType.SUB_ITEM);

            let nodePeopleItem = cc.instantiate(this.nodePeopleItem);
            nodePeopleItem.active = true;
            this.nodeSelectPeople.addChild(nodePeopleItem);

            let nodeSelectCharge = nodePeopleItem.getChildByName('nodeSelectCharge');
            this.toggleContainerArr.push(nodeSelectCharge.getComponent(cc.ToggleContainer));
            for (let j = 0; j < toggleArr.length; j++) {
                let to = toggleArr[j];

                let nodeItemCharge = cc.instantiate(this.nodeItemCharge);
                nodeSelectCharge.addChild(nodeItemCharge);
                nodeItemCharge.active = true;
                let toggle = nodeItemCharge.getComponent(cc.Toggle);
                toggle.uncheck();

                let label = cc.find('labelName', nodeItemCharge).getComponent(cc.Label);
                label.string = to;
            }   

            let nodePeople = nodePeopleItem.getChildByName('nodePeople');
            let nodeHead = cc.instantiate(this.prefabHead);
            let script = nodeHead.getComponent(SettleLawsuitPrimaryHeadNode);
            script.setCarryData({
                id: o
            });
            nodePeople.addChild(nodeHead);
        }
    }

    initLayer2() {

        // this.initPropInfo();

        // let remind_text = this._carryData.csvInfo.remind_text;
        // this.nodeHint.active = false;
        // if (utilsModel.isValidNumberValue(remind_text)) {
        //     this.nodeHint.active = true;
        //     this.labelTalkHint.string = remind_text;
        //     utilsView.refreshLabelUI(this.labelTalkHint);

        //     let height = this.labelTalkHint.node.height;
        //     height = Math.max(height + c_selfTalkSpaceY, this.minTalkHeight);
        //     this.sprHintDialog.height = height;
        //     this.labelTalkHint.node.getComponent(cc.Widget).updateAlignment();
        // }


        // let peopleArr = this._carryData.peopleArr;
        // let layout = this.nodeSelectPeople.getComponent(cc.Layout);
        // layout.spacingX = peopleArr.length <= 2 ? 70 : 10;
        // for (let i = 0; i < peopleArr.length; i++) {
        //     let o = peopleArr[i];
        //     let nodePeople = cc.instantiate(this.prefabHead);
        //     let script = nodePeople.getComponent(SettleLawsuitPrimaryHeadCheck);
        //     script.setCarryData({
        //         id: o
        //         , idx: i
        //         , parent: this
        //     });
        //     this.nodeSelectPeople.addChild(nodePeople);
        //     this.peopleScriptArr.push(script);
        // }
        // this.selectPeople(0);
    }

    selectPeople(idx: number) {
        // for (let i = 0; i < this.peopleScriptArr.length; i++) {
        //     if (i != idx) {
        //         this.peopleScriptArr[i].onUnselect();
        //     } else {
        //         this.peopleScriptArr[i].onSelect();
        //     }
        // }
        // this.curSelectPeople = idx;
        // this.curSelectType = -1;
        // this.showChargeArr();
        // this.showButton();
    }

    showChargeArr() {
        // let idx = this.curSelectPeople;
        // this.nodeSelectCharge.removeAllChildren();
        // this.checkArr = [];
        // let strSel = 'judge_select' + (idx+1);
        // let strType = 'judge_select_type' + (idx+1);
        // let judge_select = this._carryData.csvInfo[strSel];

        // let selectArr = judge_select.split(FileKind.ResParseType.BIG_ITEM);
        // let typeArr = this._carryData.csvInfo[strType].split(FileKind.ResParseType.BIG_ITEM);
        // for (let i = 0; i < selectArr.length; i++ ) {
        //     let o = selectArr[i];
        //     let nodeSel = cc.instantiate(this.nodeItemCharge);
        //     nodeSel.active = true;

        //     let toggle = cc.find('toggle', nodeSel).getComponent(cc.Toggle);
        //     toggle.uncheck();
        //     if (!typeArr[i]) {
        //         console.error(`数据不匹配`);
        //     }
        //     toggle.checkEvents[0].customEventData = typeArr[i];

        //     this.checkArr.push(toggle);

        //     let label = cc.find('labelName', nodeSel).getComponent(cc.Label);
        //     label.string = o;
        //     this.nodeSelectCharge.addChild(nodeSel);
        // }
    }

    showHighOfficaialLayer(bSuccess: boolean, retArr: string[], loseArr: string[]) {

        // let selectArr: string[] = [];
        // for (let o of this.checkArr) {
        //     if (o.isChecked) {
        //         let label = cc.find('labelName', o.node.parent).getComponent(cc.Label);
        //         selectArr.push(label.string);
        //     }
        // }
        
        // this._carryData.parent.showHighOfficaialLayer(
        //     bSuccess
        //     , retArr
        //     , loseArr
        //     , this.curSelectPeople
        //     , selectArr
        // );
    }

    initPropInfo() {
        let goodsId = GeneralKind.PropId.ASTRONOMER_MIRROR_ID;
        let itemConfig = backPackEventMap()[goodsId];
        this.labelPropName.string = itemConfig.name;

        this.refreshPropCount();
    }

    refreshPropCount() {
        let goodsId = GeneralKind.PropId.ASTRONOMER_MIRROR_ID;
        let propData = NormalGameManager._instance.getGameData().backpack[goodsId];
        let num = this.propNum = propData && propData.num || 0;
        this.labelPropNum.string = '×' + num;

        this.setPropState(num > 0);
    }

    setPropState(bEnable: boolean) {
        this.sprVideo.active = !bEnable;
        this.sprPropBg.color = bEnable ? cc.Color.WHITE : new cc.Color(0x87, 0x87, 0x87);
        this.btn_prop.node.color = bEnable ? cc.Color.WHITE : new cc.Color(0x87, 0x87, 0x87);
        this.labelPropNum.node.color = bEnable 
            ?  new cc.Color(0xFF, 0xFF, 0xF2) 
            :  new cc.Color(0xCD, 0x5C, 0x54);
    }

    onClickButtonSelect(event: cc.Event.EventTouch, data) {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        // let peopleScript = this.peopleScriptArr[this.curSelectPeople];
        // let peopleLevel = peopleScript.getLevel();

        // let gameManager = NormalGameManager._instance;
        // let gameData = gameManager.getGameData();
        // let officialLv = gameData.m_officialLv;

        // let peopleIdx = this.curSelectPeople+1;
        // let judge_type_result = this._carryData.csvInfo['judge_type_result' + peopleIdx];
        // let judge_result_award = this._carryData.csvInfo['judge_result_award' + peopleIdx];

        // let typeIdx = this.curSelectType-1;
        // if (typeIdx < 0) {
        //     console.error(`数据错误`);
        //     return;
        // }

        // let resultGroup = judge_type_result.split(FileKind.ResParseType.BIG_ITEM);
        // let awardGroup = judge_result_award.split(FileKind.ResParseType.BIG_ITEM);
        // if (!resultGroup[typeIdx]) {
        //     console.error(`数据配置错误`);
        //     return;
        // }
        
        // let idx = Number(data);
        // let resultArr = resultGroup[typeIdx].split(FileKind.ResParseType.SUB_ITEM);
        // if (!resultArr[idx]) {
        //     console.error(`数据配置错误`);
        //     return;
        // }
        // let bSuccess = resultArr[idx] == SettleLawsuitKind.ResultType.SUCCESS;
        // let awardIdx = bSuccess ? 0 : 1;
        // if (!awardGroup[0] || !awardGroup[1]) {
        //     console.error(`数据配置错误`);
        //     return;
        // }
        // let awardArr = awardGroup[awardIdx].split(FileKind.ResParseType.ITEM);
        // this.destroyNode();

        // if (peopleLevel > officialLv) {
        //     this.showHighOfficaialLayer(bSuccess, awardArr, awardGroup[1].split(FileKind.ResParseType.ITEM));
        //     return;
        // }
        // this._carryData.parent.showResultUI(bSuccess, awardArr);
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        // this.destroyNode();
        this.showUI(false);
        // ModelDialogLayer.show('确定退出衙门吗？', null, ()=> {
        //     this.destroyNode();
        //     this._carryData.parent.closeLayer();
        // });
    }

    onClickToggle(toggle: cc.Toggle, data) {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.refreshButtonState();
    }

    refreshButtonState() {
        let bCanJudge = true;
        for (let o of this.toggleContainerArr) {
            let isChecked = false;
            for (let item of o.toggleItems) {
                if (item.isChecked) {
                    isChecked = true;
                    break;
                }
            }
            if (isChecked) {
                continue;
            }
            bCanJudge = false;
            break;
        }
        this.btnJuedge.interactable = bCanJudge;
    }

    showButton() {
        // let idx = this.curSelectPeople;
        // let strBtn = 'judge_type_btn' + (idx+1);
        // let judge_type_btn = this._carryData.csvInfo[strBtn];

        // let typeIdx = this.curSelectType-1;
        // if (typeIdx < 0) {
        //     this.nodeBtn.children.forEach((v)=> {
        //         v.active = false;
        //     });
        //     return;
        // } 

        // let btnGroup = judge_type_btn.split(FileKind.ResParseType.BIG_ITEM);
        // if (!btnGroup[typeIdx]) {
        //     console.error(`数据配置错误`);
        //     return;
        // }

        // let btnArr = btnGroup[typeIdx].split(FileKind.ResParseType.SUB_ITEM);
        // this.nodeBtn.children.forEach((v, i)=> {
        //     if (i >= btnArr.length) {
        //         v.active = false;
        //         return;
        //     }
        //     v.active = true;

        //     let label = cc.find('label', v).getComponent(cc.Label);
        //     label.string = btnArr[i];

        //     let btn = v.getComponent(cc.Button);
        //     btn.clickEvents[0].customEventData = i + '';
        // });
    }

    onClickProp() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if (this.propNum > 0) {
            let goodsId = GeneralKind.PropId.ASTRONOMER_MIRROR_ID;
            NormalGameManager._instance.onOutGoods(goodsId);
            this.refreshPropCount();

            this.setSuccessSelect();
        } else {
            utilsModel.loadAndShowVideoAdTrans(()=>{
                    this.setSuccessSelect();
                }, ()=>{

                }
                , null
                , "观看广告获得钦天鉴"
            );
        }
    }

    setSuccessSelect() {
        // let csvInfo = this._carryData.csvInfo;
        // let peopleArr = this._carryData.peopleArr;
        // let bFind = false;
        // for (let i = 0; i < peopleArr.length; i++) {
        //     let idx = i+1;
        //     let judge_type_result = 'judge_type_result' + idx;
        //     let resultGroup = csvInfo[judge_type_result].split(FileKind.ResParseType.BIG_ITEM);
        //     for (let j = 0; j < resultGroup.length; j++) {
        //         let jIdx = j + 1;
        //         let splits = resultGroup[j].split(FileKind.ResParseType.SUB_ITEM);
        //         for (let k = 0; k < splits.length; k ++) {
        //             if (splits[k]  == SettleLawsuitKind.ResultType.SUCCESS) {
        //                 this.selectPeople(i);
        //                 this.setPoppleToggleEnable(false);

        //                 let judge_select_type = 'judge_select_type' + idx;
        //                 let judge_selectGroup = csvInfo[judge_select_type].split(FileKind.ResParseType.BIG_ITEM);
        //                 for (let kj = 0; kj < judge_selectGroup.length; kj++) {
        //                     if (judge_selectGroup[kj].trim() == '') {
        //                         continue;
        //                     }
        //                     this.checkArr[kj].interactable = false;
        //                     if (judge_selectGroup[kj] == jIdx) {
        //                         this.checkArr[kj].check();
        //                         this.onClickToggle(this.checkArr[kj], jIdx);
        //                     }
        //                 }
        //                 this.setButtonEnable(k);
        //                 bFind = true;
        //                 break;
        //             }
        //         }
        //         if (bFind) {
        //             break;
        //         }
        //     }
        //     if (bFind) {
        //         break;
        //     }
        // }
    }

    setButtonEnable(idx: number) {
        // this.nodeBtn.children.forEach((v, i)=> {
        //     if (!v.active) {
        //         return;
        //     }
        //     let btn = v.getComponent(cc.Button);
        //     btn.interactable = (i == idx);
        // });
    }

    setPoppleToggleEnable(bEnable: boolean) {
        // this.peopleScriptArr.forEach((v)=> {
        //     v.setToggleEnable(bEnable);
        // });
    }

    onClickStartJudge() {
        this.showUI(false);
        let selectArr: string[] = [];
        let exhibitArr: string[] = [];
        for (let o of this.toggleContainerArr) {
            for (let i = 0; i < o.toggleItems.length; i++) {
                let item = o.toggleItems[i];
                if (item.isChecked) {
                    selectArr.push(i+'');
                    break;
                }
            }
        }

        let content = this.scrollExhibit.content;
        content.children.forEach((v)=> {
            let script = v.getComponent(SettleLawsuitPrimaryExhibitItem2);  
            if (script.isSelect()) {
                exhibitArr.push(script.getGoodsId());
            }
        });

        this._carryData.parent.showJudgementUI(selectArr, exhibitArr);
    }

    showUI(visible: boolean)  {
        this.node.active = visible;
    }


    // update (dt) {}
}
